import { CircularProgress } from "@mui/material";
import { FC } from "react";

import { TableLoadingIndicatorStyled } from "./table.styled";

interface ITableLoadingIndicator {
  loading?: boolean;
}

export const TableLoadingIndicator: FC<ITableLoadingIndicator> = ({
  loading,
}) => {
  return (
    <>
      {Boolean(loading) && (
        <TableLoadingIndicatorStyled>
          <CircularProgress color="secondary" />
        </TableLoadingIndicatorStyled>
      )}
    </>
  );
};
